import { FC, ReactNode } from 'react';
import { Tooltip } from './Tooltip';
import { HelpCircle } from 'lucide-react';

interface FormLabelProps {
  children?: ReactNode;
  label?: ReactNode;
  htmlFor?: string;
  required?: boolean;
  tooltip?: string;
  className?: string;
}

export const FormLabel: FC<FormLabelProps> = ({ children, label, htmlFor, required, tooltip, className = '' }) => {
  return (
    <label htmlFor={htmlFor} className={`mb-2 flex items-center gap-1.5 nav-label text-gray-700 ${className}`}>
      {label ?? children}
      {required && <span className="text-red-500">*</span>}
      {tooltip && (
        <Tooltip content={tooltip}>
          <HelpCircle className="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-help" />
        </Tooltip>
      )}
    </label>
  );
};
